import { Injectable, inject } from '@angular/core';
import { ApiConfig } from './api-config.model';
import { ApiConfigService as NewApiConfigService } from '@wdx/clmi/clmi-swagger-gen/api-services';

/**
 * @deprecated
 * Use `import { ApiConfigService } from '@wdx/clmi/clmi-swagger-gen/api-services'` instead.
 * This service calls through to the new above version and will be removed in the future
 *  */
@Injectable({ providedIn: 'root' })
export class ApiConfigService {
    private newApiConfigService = inject(NewApiConfigService);

    set(config: ApiConfig): void {
        this.newApiConfigService.set(config);
    }

    get(): ApiConfig {
        return this.newApiConfigService.get();
    }
}
